<template>
  <ca-modal
    titulo="Registro de usuario"
    :show="show"
    boton-cancelar @cancelar="cancelar"
    boton-accion boton-accion-label="REGISTRO" @accion="registro"
  >
    Rellená los datos de registro. Tené en cuenta que para que luego puedas iniciar sesión primero tu cuenta será confirmada por el equipo de ConsorcioAbierto.
    <br>
    <v-form ref="form" v-model="valid_form">
      <v-row>
        <v-col cols=12>
          <v-text-field v-model="email" type="email" :rules="[ruleEmail]" label="Email"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="pr-2">
          <v-text-field v-model="password" type="password" :rules="[rulePassword]" label="Contraseña"/>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="password_check" type="password" :rules="[rulePassword]" label="Confirmar contraseña"/>
        </v-col>
      </v-row>
    </v-form>
  </ca-modal>
</template>

<script>
import { AUTH_SERVICE } from '@/services/auth.service';
import { LAYOUT_MUTATION_MOSTRAR_LOADING, LAYOUT_MUTATION_MODAL_EXITO, LAYOUT_MUTATION_MODAL_ERROR, LAYOUT_MUTATION_OCULTAR_LOADING } from '@/store/layout/layout.types';

export default {
  props: {
    show: {type: Boolean, default: false}
  },
  data() {
    return {
      valid_form: false,
      email: '',
      password: '',
      password_check: ''
    };
  },
  methods: {
    ruleEmail(v) {
      if (!v)
        return 'Email requerido';
      return true;
    },

    rulePassword(v) {
      if (!v)
        return 'Contraseña requerida';
      if (v.length < 8)
        return 'La contraseña debe tener al menos 8 caracteres';
      if (this.password !== this.password_check && this.password_check && this.password)
        return 'Las contraseñas no coinciden';

      return true;
    },

    /**
		 * Valida que los campos del form sean válidos, si es así realiza signup de usuario en AWS.
		 *
		 * Informa correspondientemente si el signup fue éxitoso o no.
		 */
    registro() {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (!this.valid_form) {
          return;
        }

        this.$emit('update:show', false);
        this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
        AUTH_SERVICE.registrarse(this.email, this.password)
          .then(() => {
            this.$store.commit(LAYOUT_MUTATION_MODAL_EXITO, {texto: 'La solicitud de registro fue enviada éxitosamente, aguarda nuestra confirmación para poder acceder al sistema.'});
          })
          .catch(() => {
            // ToDo revisar wording
            this.$store.commit(LAYOUT_MUTATION_MODAL_ERROR, {texto: 'Ocurrió un error al realizar el registro, por favor contactate con nosotros para solucionarlo.'});
          })
          .then(() => this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING));
      });
    },

    /**
		 * Hookeado a botón cancelar de modal
		 */
    cancelar() {
      this.$emit('update:show', false);
    }
  }
};
</script>

<style lang="scss">

</style>